<template>
<el-container>
    <el-main>
        <el-col :span="24">
            <Genefig2 :species="species" :tissue="tissue" />
        </el-col>
        <el-col :span="24">
            <Genefig1 :species="species" :gene="gene" />
        </el-col>
        <el-col :span="24">
            <Genefig :species="species" :tissue="tissue" :gene="gene" />
        </el-col>
        <el-col :span="24">
            <Genelist :species="species" :tissue="tissue" :gene="gene" />
        </el-col>
    </el-main>
    </el-container>
</template>

<script>
import Genefig1 from './Genefig1.vue';
import Genefig from './Genefig.vue';
import Genelist from './Genelist.vue';
import Genefig2 from './Genefig2.vue';

export default {
    components: { 
        Genefig1,Genefig, Genelist,Genefig2
    },
    props: {
        species: {
            type: String,
            required: true
        },
        tissue: {
            type: [String, Array], // 现在它可以接受字符串或数组
            required: true
        },
        gene: {
            type: String,
            required: true
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/home/Genepanel.vue